import styled from 'styled-components'

export const ContactContainer = styled.div`
  padding: 3rem var(--paddingD) 10rem;

  h1 {
    font-size: 40px;
    font-weight: 700;
  }

  .form-container {
    width: 50%;
    display: none;

    &.active {
      display: block;
    }
  }

  #_form_31_,
  #_form_32_,
  #_form_33_ {
    line-height: 1.6;
    text-align: left;
    border: 1px solid var(--grey3);
    border-radius: 10px;
    padding: 2rem;
    color: var(--grey2);
    box-shadow: 0px 0px 20px rgba(120, 121, 241, 0.2);
  }

  input,
  select,
  textarea {
    color: var(--grey2);
    border-color: var(--grey3) !important;
    margin: 0;
  }

  textarea {
    resize: none;
  }

  ._form-thank-you {
    position: relative;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 18px;
  }

  div._form_element {
    margin-bottom: 2rem;
  }

  ._form-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: min-content;
  }

  ._field-is-afya {
    fieldset {
      border: none;
    }

    ._checkbox-radio {
      &:first-child {
        margin-right: 8rem;
      }

      input {
        margin-right: 0.25rem;
      }
    }
  }

  ._field-department,
  ._field-name,
  ._field-institution,
  ._field-is-afya,
  ._field-message {
    grid-column: 1 / 3;
  }

  ._field-email,
  ._field-country {
    margin-right: 0.5rem;
  }

  ._field-phone,
  ._field-profession {
    margin-left: 0.5rem;
  }

  ._form-label,
  ._form_element ._form-label {
    margin-bottom: 0.75rem;
    display: block;
  }

  ._field-wrapper {
    position: relative;
  }

  ._clear-element {
    clear: left;
  }

  input[type='text']._has_error,
  textarea._has_error {
    border: #f37c7b 1px solid !important;
  }

  input[type='checkbox']._has_error {
    outline: #f37c7b 1px solid !important;
  }

  ._error {
    display: block;
    position: absolute;
    font-size: 14px;
    z-index: 1;
  }

  ._error._above {
    padding-bottom: 4px;
    bottom: 39px;
    right: 0;
  }

  ._error._below {
    padding-top: 4px;
    top: 100%;
    right: 0;
  }

  ._error._above ._error-arrow {
    bottom: 0;
    right: 15px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #f37c7b;
  }

  ._error._below ._error-arrow {
    top: 0;
    right: 15px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #f37c7b;
  }

  ._error-inner {
    padding: 8px 12px;
    background-color: #f37c7b;
    font-size: 14px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
  }

  ._error-inner._form_error {
    margin-bottom: 5px;
    text-align: left;
  }

  ._button-wrapper ._error-inner._form_error {
    position: static;
  }

  ._error-inner._no_arrow {
    margin-bottom: 10px;
  }

  ._error-arrow {
    position: absolute;
    width: 0;
    height: 0;
  }

  ._error-html {
    margin-bottom: 10px;
  }

  @media all and (min-width: 320px) and (max-width: 667px) {
    ::-webkit-scrollbar {
      display: none;
    }

    #_form_31_ *,
    #_form_32_ *,
    #_form_33_ * {
      font-size: 1em;
    }

    ._form-title,
    ._inline-style {
      margin-top: 0;
      margin-right: 0;
      margin-left: 0;
    }
  }
`

export const Desktop = styled.div`
  h1 {
    font-size: 40px;
  }
`

export const Mobile = styled.div`
  .form-container {
    width: 100%;
    margin-bottom: 3rem;
  }

  ._form-content {
    display: block;
  }

  h1 {
    font-size: 32px;
    color: var(--grey8);
    text-align: center;
    margin-bottom: 3rem;
  }
`

export const TextContainer = styled.div`
  width: 36%;
  padding-right: 2rem 1.75rem;
  color: var(--grey8);

  span,
  p {
    &.contact {
      font-size: 16px;
      font-weight: 500;
    }

    &.material-icons-round {
      font-size: 30px;
      color: var(--blue);
      margin-right: 1rem;
    }
  }

  img.material-icons {
    width: 30px;
    margin-right: 1rem;
    filter: invert(24%) sepia(33%) saturate(6510%) hue-rotate(243deg)
      brightness(96%) contrast(89%);
  }

  & > *:not(:last-child) {
    margin-bottom: 2.5rem;
  }

  @media only screen and (max-width: 900px) {
    width: 100%;
    text-align: center;

    p.contact {
      font-size: 14px;
    }

    .material-icons,
    .material-icons-round {
      margin: 0 0 1rem !important;
    }
  }
`

export const FormContainer = styled.div`
  width: 50%;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(120, 121, 241, 0.2);

  div {
    margin-bottom: 2rem;

    &.flexbox > section {
      width: 48%;
    }
  }

  input,
  textarea {
    margin-top: 0.75rem !important;
  }

  textarea {
    resize: none;
  }

  section {
    width: 100%;
  }

  @media only screen and (max-width: 900px) {
    width: 100%;
    margin-bottom: 3rem;

    section:not(:last-child) {
      margin-bottom: 2rem;
    }
  }
`
